export default __webpack_public_path__ + "static/media/sv11_kr_jing_b3.1e2dbb45.mp3";